/**
 * A leaf of `helpers/commonHelpers` — no store, no platform API — so the my-orders v2 View can
 * import it under `node --test` (the folder's `shared.ts` reaches the store through `getBranchId`).
 * `shared.ts` re-exports it, so `@rista/core/helpers/commonHelpers` still offers the name.
 */

/**
 * "98******10" — the display form of a customer's number: first two digits, last two, stars
 * between. Web's; uplifted 2026-09-16 for the digital-bill sheet (mobile showed the number in the
 * clear). The `showUnmaskedNumber` placeholder is web's own: the permission it waits for does not
 * exist yet.
 *
 * 🔴 (release_4.0.0's note, kept at the 2026-09-24 merge) **This is not `helpers/customerHelpers`'
 * `maskPhoneNumber`, and the two are not interchangeable.** That one masks by `substr` + `replace`
 * and answers `8*******46`; this one slices and answers `87******46`. Unifying them would silently
 * restyle every screen that shows a number. `apps/web`'s customer summary, KOT view, cart, digital
 * bill, post-sale popup and reservation modals all print THIS one.
 */
export const maskPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) return "";
  const showUnmaskedNumber = false;
  if (showUnmaskedNumber) return phoneNumber;
  return `${phoneNumber.slice(0, 2)}${"*".repeat(Math.max(phoneNumber.length - 4, 0))}${phoneNumber.slice(-2)}`;
};
